import {CommonReducer, ReducerFromState} from "../../@types/reducers";
import {LiveMarketData} from "../../@types/response";

export const getLiveMarkets = (state: ReducerFromState<CommonReducer>): LiveMarketData => state.common.liveMarkets;